/**
 * Checks for invalid characters within the provided authority.
 *
 * @param {string} authority A string containing the URL authority.
 *
 * @example
 * ```js
 * const isValid = isValidAuthority( 'www.gechiui.com' ); // true
 * const isNotValid = isValidAuthority( 'gechiui#org' ); // false
 * ```
 *
 * @return {boolean} True if the argument contains a valid authority.
 */
export function isValidAuthority( authority ) {
	if ( ! authority ) {
		return false;
	}
	return /^[^\s#?]+$/.test( authority );
}
